import type { IconNode } from '../types';

/**
 * @name laser
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTMgOCAuOTUtLjk1IiAvPgogIDxwYXRoIGQ9Ik0xMy45NSAxNi45NSAxMyAxNiIgLz4KICA8cGF0aCBkPSJNMjIgMTJoLTkiIC8+CiAgPHBhdGggZD0iTTQgMTJIMiIgLz4KICA8cGF0aCBkPSJNNC4wNSAxNi45NSA1IDE2IiAvPgogIDxwYXRoIGQ9Im01IDgtLjk1LS45NSIgLz4KICA8cGF0aCBkPSJNOSAxMmguMDEiIC8+CiAgPHBhdGggZD0iTTkgMTl2LTIiIC8+CiAgPHBhdGggZD0iTTkgN1Y1IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/laser
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Laser: IconNode = [
  ['path', { d: 'm13 8 .95-.95' }],
  ['path', { d: 'M13.95 16.95 13 16' }],
  ['path', { d: 'M22 12h-9' }],
  ['path', { d: 'M4 12H2' }],
  ['path', { d: 'M4.05 16.95 5 16' }],
  ['path', { d: 'm5 8-.95-.95' }],
  ['path', { d: 'M9 12h.01' }],
  ['path', { d: 'M9 19v-2' }],
  ['path', { d: 'M9 7V5' }],
];

export default Laser;
